import Styles from './styles.module.css';
import 'firebase/auth'
import React, { useState, useEffect } from 'react';
import DefaultTitle from '../../../../../package/title/index';
import Image1 from './../../../../../../image/salonType/1.png';
import Image2 from './../../../../../../image/salonType/2.png';
import Image3 from './../../../../../../image/salonType/3.png';
import Image4 from './../../../../../../image/salonType/4.png';
import Image5 from './../../../../../../image/salonType/5.png';
import Image6 from './../../../../../../image/salonType/6.png';
import Image7 from './../../../../../../image/salonType/7.png';
import Image8 from './../../../../../../image/salonType/8.png';
import { doc, getDoc, getFirestore, updateDoc } from 'firebase/firestore';

type RecruitEditStorTypeProps = {
  editType: string;
  setEditType: React.Dispatch<React.SetStateAction<string>>;
};

const RecruitEditStorType: React.FC<RecruitEditStorTypeProps> = ({ editType, setEditType }) => {


  const db = getFirestore();

  const [ companyId, setCompanyId ] = useState('');

  const [ region, setRegion ] = useState(false);
  const [ strengths, setStrengths ] = useState(false);
  const [ treatment, setTreatment ] = useState(false);

  const [ statusPentagon, setStatusPentagon ] = useState(false);
  const [ statusPlace, setStatusPlace ] = useState(false);


  useEffect(() => {
    const fetchStoreData = async () => {
      try {
        const docRef = doc(db, 'stores', editType);
        const docSnap = await getDoc(docRef);
  
        if (!docSnap.exists()) return;
  
        const data = docSnap.data();
        setCompanyId(data.companyId);

        setRegion(data.region ?? false);
        setStrengths(data.strengths ?? false);
        setTreatment(data.treatment ?? false);
        setStatusPentagon(data.status_pentagon ?? false);
        setStatusPlace(data.status_place ?? false);
      } catch (error) {
        console.error("店舗データの取得に失敗しました:", error);
      }
    };
  
    fetchStoreData();
  }, []);

  function check() {
    window.scrollTo(0, 0);
    save(true);
  }

  async function save(isTypeActive: boolean) {
    const db = getFirestore();
    const recruitId = `${companyId}_2027`;

    // type名を判定する関数を分離（読みやすく、再利用もしやすい）
    const getSalonType = (region: boolean, strengths: boolean, treatment: boolean): string => {
      const typeMap: Record<string, string> = {
        "true-true-true": "有名サロン",
        "true-true-false": "トレンドサロン",
        "true-false-true": "おしゃれサロン",
        "true-false-false": "ビューティーサロン",
        "false-true-true": "オールラウンドサロン",
        "false-true-false": "愛されサロン",
        "false-false-true": "密着サロン",
        "false-false-false": "こだわりサロン",
      };

      return typeMap[`${region}-${strengths}-${treatment}`] ?? "";
    };

    const typeName = getSalonType(region, strengths, treatment);

    // Firestore更新データ
    const storeData = {
      status: statusPlace && statusPentagon && isTypeActive,
      status_type: isTypeActive,
      region,
      strengths,
      treatment,
      type: typeName,
    };

    // Firestore更新（storesコレクション）
    await updateDoc(doc(db, "stores", editType), storeData);
    setEditType('');

    // Firestore更新（recruitsコレクション）※isTypeActiveがfalseのときのみ
    if (!isTypeActive) {
      await updateDoc(doc(db, "recruits", recruitId), {
        store: { isCompleted: isTypeActive },
      });
    }
  }

  return (
    <div className={Styles.box}>

      <div className={Styles.box_inner}>
        <div className={Styles.box_black} onClick={() => setEditType('')}></div>
        <div className={Styles.box_contents}>

          <div className={Styles.header}>
            <h3 className={Styles.headerTitle}>8タイプ診断</h3>
            <div className={Styles.headerBtns}>
              <button type="button" className={Styles.backBtn} onClick={() => setEditType('')}>戻る</button>
              <button type="button" className={Styles.saveBtn} onClick={() => check()}>保存</button>
            </div>
          </div>

          <div className={Styles.body}>

          <DefaultTitle title={'顧客層'} />

          <div className={Styles.radio_btn}>
            <div>
              <input type="radio" name='1' checked={region === true} onClick={() => setRegion(true)} />
              <p>都会型サロン</p>
            </div>
            <div>
              <input type="radio" name='1' checked={region === false} onClick={() => setRegion(false)} />
              <p>地域型サロン</p>
            </div>
          </div>
          
          <DefaultTitle title={'強み'} />

          <div className={Styles.radio_btn}>
            <div>
              <input type="radio" name='2' checked={strengths === true} onClick={() => setStrengths(true)} />
              <p>集客力</p>
            </div>
            <div>
              <input type="radio" name='2' checked={strengths === false} onClick={() => setStrengths(false)} />
              <p>技術力</p>
            </div>
          </div>
          
          <DefaultTitle title={'施術幅'} />

          <div className={Styles.radio_btn}>
            <div>
              <input type="radio" name='3' checked={treatment === true} onClick={() => setTreatment(true)} />
              <p>オールマイティー</p>
            </div>
            <div>
              <input type="radio" name='3' checked={treatment === false} onClick={() => setTreatment(false)} />
              <p>専門的</p>
            </div>
          </div>

          <h5 className={Styles.title}>サロンタイプ</h5>
          
          {
            region && strengths && treatment ? <img src={Image1} alt='' /> :
            region && strengths && !treatment ? <img src={Image2} alt='' /> :
            region && !strengths && treatment ? <img src={Image3} alt='' /> :
            region && !strengths && !treatment ? <img src={Image4} alt='' /> :
            !region && strengths && treatment ? <img src={Image5} alt='' /> :
            !region && strengths && !treatment ? <img src={Image6} alt='' /> :
            !region && !strengths && treatment ? <img src={Image7} alt='' /> :
            !region && !strengths && !treatment ? <img src={Image8} alt='' /> : <></>
          }
        
          </div>

        </div>
      </div>
    </div>
  );
}

export default RecruitEditStorType;